module.exports = __webpack_public_path__ + "media/images/symbols/signature-88d4f7b0032c44de7e736c9f6a40afc8.svg";